module.exports = __webpack_public_path__ + "static/MortgageAwardsWinners2023-Mortgage_Lender_Customer_Service_of_the_Year-f72afec4ee7122ecc66a39a42043fab3.jpg";